<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius12px"
    style="background: #e5e9ec"
  >
    <div class="well form-group" style="background: #e5e9ec">
      <!--title -->
      <div class="grid-title no-border borderTop" style="display: flex; justify-content: space-between; align-items: center; padding-right: 20px;">
        <h4 style="padding-left: 6px">
          {{ i18nValues["researchOrderAdmin"] }}
        </h4>
        <el-button
          v-if="componentsMap.get('researchOrder_create')"
          icon="fas fa-plus"
          size="small"
          class="btn-primary"
          @click="add()"
        >
          {{ i18nValues["addResearchOrder"] }}
        </el-button>
      </div>

      <!-- card body -->
      <div class="grid-body no-border borderBottom">
        <el-form>
          <div class="filters-wrapper">
            <div class="filters-row">
              <!-- search by shipment -->
              <el-form-item :label="i18nValues['shipment']" prop="shipment">
                <el-input
                  v-model="filter.shipment"
                  :placeholder="i18nValues['shipment']"
                ></el-input>
              </el-form-item>

              <!-- search by date-->
              <el-form-item :label="i18nValues['date']" prop="date">
                <div class="input-group">
                  <el-date-picker
                    v-model="filter.date"
                    type="date"
                    format="dd/MM/yyyy"
                    :clearable="true"
                    :placeholder="i18nValues['date']"
                  >
                  </el-date-picker>
                  <span class="input-group-addon primary el-input__suffix icon">
                    <span class="arrow"></span>
                    <i class="fa fa-calendar-alt"></i>
                  </span>
                </div>
              </el-form-item>

              <!-- search by area -->
              <el-form-item :label="i18nValues['area']" prop="area">
                <el-input
                  v-model="filter.area"
                  :placeholder="i18nValues['area']"
                ></el-input>
              </el-form-item>

              <!-- search by responsable -->
              <el-form-item :label="i18nValues['responsable']" prop="responsable">
                <el-input
                  v-model="filter.responsable"
                  :placeholder="i18nValues['responsable']"
                ></el-input>
              </el-form-item>

              <!-- search button -->
              <el-button
                @click="retrieveResearchOrdersBySearch()"
                icon="fas fa-search"
                id="searchButton"
                size="small"
                class="btn-primary"
              >
                {{ i18nValues["search"] }}
              </el-button>
            </div>
          </div>

          <!-- table -->
          <div class="full-width table-container" v-loading="loading" style="margin:0 auto;padding:20px;">
            <el-table
              :data="ResearchOrderSubList"
              class="table table-hover table-striped"
              id="I&DTable"
              align="center"
              :empty-text="hasAttemptedLoad ? i18nValues['noDataAvailable'] : ''"
              @sort-change="handleSortChange"
            >
              <!-- ID -->
              <el-table-column
                prop="id"
                :label="i18nValues['number']"
                width="75"
                align="left"
                sortable
              ></el-table-column>

              <!-- SHIPMENT -->
              <el-table-column
                prop="shipment"
                :label="i18nValues['shipment']"
                width="75"
                align="left"
                sortable
              ></el-table-column>

              <!-- DATE -->
              <el-table-column
                prop="date"
                :label="i18nValues['date']"
                :formatter="formatDateRow"
                width="75"
                align="center"
                sortable
              ></el-table-column>

              <!-- AREA -->
              <el-table-column
                prop="area"
                :label="i18nValues['area']"
                width="75"
                align="center"
                sortable
              ></el-table-column>

              <!-- RESPONSABLE -->
              <el-table-column
                :label="i18nValues['responsable']"
                prop="responsable"
                width="75"
                align="right"
                sortable
              ></el-table-column>

              <!-- EDIT/DELETE -->
              <el-table-column width="90" align="right">
                <template slot-scope="scope">
                  <el-button
                    v-if="isReadOnly()"
                    fixed="right"
                    class="text-info"
                    icon="fa fa-eye"
                    size="small"
                    :title="i18nValues['view']"
                    @click="edit(scope.row.id)"
                  ></el-button>

                  <el-button
                    v-if="componentsMap.get('researchOrder_modification')"
                    class="text-info"
                    icon="fas fa-edit"
                    size="small"
                    :title="i18nValues['edit']"
                    @click="edit(scope.row.id)"
                  ></el-button>

                  <el-button
                    v-if="
                      componentsMap.get('researchOrder_delete') &&
                        !scope.row.palletScanned
                    "
                    class="text-danger"
                    icon="fas fa-times"
                    size="small"
                    :title="i18nValues['remove']"
                    @click="deleteResearchOrder(scope.row.id)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-if="90 > 10" style="height: 15px"></div>
            <div class="pagination-bar">
              <PaginationFunctional
                ref="pagination"
                sublistName="ResearchOrderSubList"
                :fullList="ResearchOrderList"
                :tableSize="20"
                :tableIndexInitial="initialPage"
                @paginationChange="paginationChange"
                @currentIndexPagination="setCurrentPage"
                class="text-center"
              />
              <div v-if="ResearchOrderList.length > 0" class="results-info">
                <p>
                  {{ i18nValues["showing"] || "Showing" }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues["of"] || "of" }} {{ totalRecords }} {{ i18nValues["results"] || "results" }}
                </p>
              </div>
            </div>
          </div>

        </el-form>

      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import PaginationFunctional from "@/components/PaginationFunctional.vue";
export default {
  name: "ResearchOrderAdmin",
  created() {
    this.restoreFromQuery();
  },

  components: {
    PaginationFunctional,
  },

  computed: {
    loading: get("researchOrder/loading"),
    globalFieldSite: get("globalFieldSite"),
    globalCampaign: get("globalCampaign"),

    // Pagination helpers for results label
    currentPage() {
      if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) {
        return this.$refs.pagination.tableIndex;
      }
      return this.initialPage || 1;
    },
    pageSize() {
      return 20; // Keep in sync with PaginationFunctional :tableSize
    },
    totalRecords() {
      if (Array.isArray(this.ResearchOrderList)) {
        return this.ResearchOrderList.length;
      }
      return typeof this.cantidad === "number" ? this.cantidad : 0;
    },
    startIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const start = (this.currentPage - 1) * this.pageSize + 1;
      return Math.min(start, this.totalRecords);
    },
    endIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const end = this.currentPage * this.pageSize;
      return Math.min(end, this.totalRecords);
    },
  },

  props: {
    componentsMap: {},
  },

  watch: {
    globalFieldSite: {
      immediate: true,
      handler(newVal, oldVal) {
        if (!newVal || !newVal.id) return;
        if (oldVal && oldVal.id === newVal.id) return;
        this.requestGeneration++;
        // Reset filters only when context actually changes (not on initial load)
        if (oldVal && oldVal.id) {
          this.filter.shipment = null;
          this.filter.date = null;
          this.filter.area = null;
          this.filter.responsable = null;
        }
        this.fetchResearchOrders(true);
        this.retrieveResearchOrderCount();
      },
    },
    globalCampaign: {
      immediate: true,
      handler(newVal, oldVal) {
        if (!this.globalFieldSite || !this.globalFieldSite.id) return;
        if (newVal && oldVal && newVal.id === oldVal.id) return;
        this.fetchResearchOrders(true);
        this.retrieveResearchOrderCount();
      },
    },
  },

  data() {
    const q = this.$route ? this.$route.query || {} : {};
    return {
      filter: {
        shipment: q.shipment || null,
        date: q.date ? this.parseDate(q.date) : null,
        area: q.area || null,
        responsable: q.responsable || null,
        fieldSiteId: null,
        campaignId: null,
      },
      ResearchOrderList: [],
      ResearchOrderSubList: [],
      originalResearchOrderList: [],
      cantidad: 100,
      initialPage: q.page ? Number(q.page) : 1,
      sortProp: q.sortProp || null,
      sortOrder: q.sortOrder || null,
      requestGeneration: 0,
      hasAttemptedLoad: false,
    };
  },
  methods: {
    fetchResearchOrders(preservePage) {
      if (!this.globalFieldSite || !this.globalFieldSite.id) {
        this.ResearchOrderList = [];
        this.ResearchOrderSubList = [];
        this.originalResearchOrderList = [];
        return;
      }
      this.hasAttemptedLoad = true;
      const gen = this.requestGeneration;
      const payload = {
        shipment: this.filter.shipment || null,
        date: this.filter.date ? new Date(this.filter.date).getTime() : null,
        area: this.filter.area || null,
        responsable: this.filter.responsable || null,
        fieldSiteId: this.globalFieldSite.id,
        campaignId: this.globalCampaign ? this.globalCampaign.id : null,
      };
      const hasFilters = !!(payload.shipment || payload.date || payload.area || payload.responsable);
      const action = hasFilters
        ? "researchOrder/retrieveResearchOrdersBySearch"
        : "researchOrder/retrieveResearchOrders";
      this.$store.dispatch(action, payload).then((res) => {
        if (gen !== this.requestGeneration) return;
        if (!res || res.length === 0) {
          this.ResearchOrderList = [];
          this.ResearchOrderSubList = [];
          this.originalResearchOrderList = [];
          this.syncRouteFromState();
          return;
        }
        // Mark palletScanned flag
        for (var i = 0; i < res.length; i++) {
          for (var j = 0; j < (res[i].pallets || []).length; j++) {
            if (res[i].pallets[j].fieldSite != null && res[i].pallets[j].fieldSite.id != null) {
              res[i].palletScanned = true;
            }
          }
        }
        this.originalResearchOrderList = res;
        // Apply current sort
        if (this.sortProp && this.sortOrder) {
          const dir = this.sortOrder === "descending" ? -1 : 1;
          this.ResearchOrderList = [...res].sort((a, b) => {
            const aVal = a[this.sortProp];
            const bVal = b[this.sortProp];
            if (aVal == null && bVal == null) return 0;
            if (aVal == null) return 1;
            if (bVal == null) return -1;
            return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: "base" }) * dir;
          });
        } else {
          this.ResearchOrderList = res;
        }
        if (!preservePage) this.initialPage = 1;
        this.syncRouteFromState();
        this.$nextTick(() => {
          const page = preservePage ? (this.initialPage || 1) : 1;
          if (this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
            this.$refs.pagination.currentChange(page);
          }
        });
      });
    },

    retrieveResearchOrdersBySearch() {
      this.fetchResearchOrders(false);
    },

    add() {
      this.$router.push({
        name: `ResearchOrderEdition`,
        params: { id: "0" },
      });
    },

    edit(id) {
      this.$router.push({
        name: `ResearchOrderEdition`,
        params: { id: id },
      });
    },

    deleteResearchOrder(id) {
      this.$confirm("Está seguro que quiere eliminar la I&D?", "Eliminar I&D", {
        distinguishCancelAndClose: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        type: "warning",
      }).then(() => {
        this.$store
          .dispatch("researchOrder/deleteResearchOrder", id)
          .then((res) => {
            if (res.status == "OK") {
              this.$notify.success({
                title: this.i18nValues["success"],
                message: this.i18nValues["researchOrderDeleted"],
                position: "bottom-right",
              });
              // Preserve current filters, sort and page after delete
              this.fetchResearchOrders(true);
              this.retrieveResearchOrderCount();
            } else {
              this.$notify.error({
                title: this.i18nValues["error"],
                message: this.i18nValues["cantDeleteResearchOrder"],
                position: "bottom-right",
              });
            }
          });
      });
    },

    formatDateRow(row) {
      return this.formatDate(row.date);
    },

    retrieveResearchOrderCount() {
      if (!this.globalFieldSite || !this.globalFieldSite.id) return;
      const gen = this.requestGeneration;
      const filter = {
        fieldSiteId: this.globalFieldSite.id,
        campaignId: this.globalCampaign ? this.globalCampaign.id : null
      };
      this.$store
        .dispatch("researchOrder/countResearchOrders", filter)
        .then((res) => {
          if (gen !== this.requestGeneration) return;
          this.cantidad = res;
        });
    },

    handleSortChange(event) {
      const nextProp = event && event.prop ? event.prop : null;
      const nextOrder = event && event.order ? event.order : null;
      if (this.sortProp === nextProp && this.sortOrder === nextOrder) return;
      this.sortProp = nextProp;
      this.sortOrder = nextOrder;

      const currentPage = this.$refs.pagination && this.$refs.pagination.tableIndex
        ? this.$refs.pagination.tableIndex
        : this.initialPage || 1;
      this.initialPage = currentPage;

      if (this.sortProp && this.sortOrder && this.originalResearchOrderList.length) {
        const dir = this.sortOrder === "descending" ? -1 : 1;
        this.ResearchOrderList = [...this.originalResearchOrderList].sort((a, b) => {
          const aVal = a[this.sortProp];
          const bVal = b[this.sortProp];
          if (aVal == null && bVal == null) return 0;
          if (aVal == null) return 1;
          if (bVal == null) return -1;
          return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: "base" }) * dir;
        });
      } else {
        this.ResearchOrderList = [...this.originalResearchOrderList];
      }

      this.syncRouteFromState();
      this.$nextTick(() => {
        if (this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
          this.$refs.pagination.currentChange(currentPage);
        }
      });
    },

    paginationChange(evt) {
      if (evt && evt.list) {
        this.ResearchOrderSubList = evt.list;
      }
      this.syncRouteFromState();
    },

    setCurrentPage(idx) {
      if (typeof idx === "number") {
        this.initialPage = idx;
        this.syncRouteFromState();
      }
    },

    // --- Query sync helpers ---
    restoreFromQuery() {
      const q = this.$route.query || {};
      this.filter.shipment = q.shipment || null;
      this.filter.date = q.date ? this.parseDate(q.date) : null;
      this.filter.area = q.area || null;
      this.filter.responsable = q.responsable || null;
      if (q.page) this.initialPage = Number(q.page);
      if (q.sortProp) this.sortProp = q.sortProp;
      if (q.sortOrder) this.sortOrder = q.sortOrder;
    },

    syncRouteFromState() {
      const q = {};
      if (this.filter.shipment) q.shipment = this.filter.shipment;
      if (this.filter.date) q.date = this.serializeDate(this.filter.date);
      if (this.filter.area) q.area = this.filter.area;
      if (this.filter.responsable) q.responsable = this.filter.responsable;
      const page = this.$refs.pagination && this.$refs.pagination.tableIndex
        ? this.$refs.pagination.tableIndex
        : this.initialPage || 1;
      if (page && page > 1) q.page = String(page);
      if (this.sortProp) q.sortProp = this.sortProp;
      if (this.sortOrder) q.sortOrder = this.sortOrder;
      if (this.globalFieldSite && this.globalFieldSite.id) q.fieldSiteId = String(this.globalFieldSite.id);
      if (this.globalCampaign && this.globalCampaign.id) q.campaignId = String(this.globalCampaign.id);
      // Only navigate if query actually changed
      const current = this.$route.query || {};
      const keys = new Set([...Object.keys(q), ...Object.keys(current)]);
      let same = true;
      for (const k of keys) {
        if (String(q[k] || "") !== String(current[k] || "")) { same = false; break; }
      }
      if (!same) {
        this.$router.replace({ query: q }).catch(() => {});
      }
    },

    serializeDate(d) {
      try {
        const dt = new Date(d);
        const y = dt.getFullYear();
        const m = `${dt.getMonth() + 1}`.padStart(2, '0');
        const day = `${dt.getDate()}`.padStart(2, '0');
        return `${y}-${m}-${day}`;
      } catch(e) { return undefined; }
    },

    parseDate(s) {
      const dt = new Date(s);
      return isNaN(dt.getTime()) ? null : dt;
    },
  },
};
</script>

<style scoped>
/* Filters wrapper - single horizontal line */
.filters-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filters-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 8px;
}

.filters-row /deep/ .el-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

/* Make inputs narrower */
.filters-row /deep/ .el-input,
.filters-row /deep/ .el-select {
  width: 140px;
}

/* Date picker slightly wider */
.filters-row /deep/ .el-date-editor {
  width: 150px;
}


/* Buttons in the same row, aligned to bottom */
.filters-row /deep/ .el-button {
  flex-shrink: 0;
}

/* Table container with minimum height to prevent loading overlay jumping */
.table-container {
  min-height: 400px;
  position: relative;
}

/* Pagination + results inline */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266;
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}
</style>
